"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WixBIHeaderName = void 0;
exports.biHeaderGenerator = biHeaderGenerator;
exports.WixBIHeaderName = 'x-wix-bi-gateway';
function biHeaderGenerator(apiMetadata, publicMetadata, environment) {
    return {
        [exports.WixBIHeaderName]: objectToKeyValue({
            environment: `js-sdk${environment ? `-${environment}` : ``}`,
            'package-name': apiMetadata.packageName ?? publicMetadata?.PACKAGE_NAME,
            'method-fqn': apiMetadata.methodFqn,
            entity: apiMetadata.entityFqdn,
        }),
    };
}
function objectToKeyValue(input) {
    return Object.entries(input)
        .filter(([_, value]) => Boolean(value))
        .map(([key, value]) => `${key}=${value}`)
        .join(',');
}
